<template>
<div class="chapter">
<div class="inner_page">
<p class="chhead"><b>GALLERY</b></p>
<p class="fig"><img alt="" src="images/pg5.jpg"/></p>
<p class="fig"><img alt="" src="images/pg5a.jpg"/></p>
<p class="fig"><img alt="" src="images/pg5b.jpg"/></p>
<p class="fig"><img alt="" src="images/pg5_4.jpg"/></p>
<p class="fig"><img alt="" src="images/pg6.jpg"/></p>
<p class="fig"><img alt="" src="images/pg6a.jpg"/></p>
<p class="fig"><img alt="" src="images/pg6_4.jpg"/></p>
<p class="fig"><img alt="" src="images/pg6b.jpg"/></p>
<p class="fig"><img alt="" src="images/pg7.jpg"/></p>
<p class="fig"><img alt="" src="images/pg7a.jpg"/></p>
<p class="fig"><img alt="" src="images/pg7b.jpg"/></p>
<p class="fig"><img alt="" src="images/pg7_4.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_chapter01.vue?78f26c30